<div *ngIf="linesInFile > 0">
  <a href="javascript:void(0)" *ngIf="isdownloadLatest" (click)="svcCall()()">{{'chargeback.eFile.eFilesPopUps.downloadLatest' | translate}}</a>
</div>
<div>
  <a href="javascript:void(0)" *ngIf="isdownloadOlder" (click)="svcCall()()">{{'chargeback.eFile.eFilesPopUps.downloadOlder' | translate}}</a>
</div>
